import { render, staticRenderFns } from "./tax.vue?vue&type=template&id=47ccaf20&scoped=true&"
import script from "./tax.vue?vue&type=script&lang=js&"
export * from "./tax.vue?vue&type=script&lang=js&"
import style0 from "./tax.vue?vue&type=style&index=0&id=47ccaf20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ccaf20",
  null
  
)

export default component.exports